import type { StyleProp, TextStyle } from 'react-native';
import { Trans } from 'react-i18next';
import { Text, type TextProps } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';

import { getDefaultTransComponents } from './utils';
import type { ComponentProps } from 'react';

type RichTextProps = {
  text: string;
  values?: Record<string, string | number>;
  onPressLink?: (href: string) => void;
  customNodes?: Record<string, React.ReactElement>;
  fontToken?: React.ComponentProps<typeof Text>['type'];
  ParentComponent?: React.ComponentType;
  style?: StyleProp<TextStyle>;
  color?: TextProps['color'];
  testID?: string;
} & Omit<ComponentProps<typeof Trans>, 'style' | 'color'>;

export function RichText({
  text,
  values = {},
  onPressLink,
  customNodes,
  style,
  ParentComponent,
  fontToken = '$bodyBase.default',
  ...rest
}: RichTextProps) {
  const defaultTransComponents = getDefaultTransComponents(onPressLink, customNodes, fontToken);

  return (
    <Trans
      i18n={i18n}
      defaults={text}
      values={values}
      parent={ParentComponent ?? Text}
      type={fontToken}
      components={defaultTransComponents}
      style={style}
      {...rest}
    />
  );
}
